import LegalLayout from "@/components/LegalLayout";

/**
 * Condizioni di Vendita delle RecenUp Card NFC — documento separato dai
 * Termini di Servizio SaaS. Applicabile solo quando l'Utente acquista il
 * prodotto fisico "RecenUp Card".
 */
export default function SalesTerms() {
  return (
    <LegalLayout title="Condizioni di Vendita — RecenUp Card" updatedAt="Febbraio 2026">
      <p>
        Le presenti Condizioni Generali di Vendita disciplinano gli acquisti delle
        <strong> RecenUp Card</strong> (card NFC + QR brandizzata) effettuati sulla
        piattaforma RecenUp. Sono integrate dai{" "}
        <a href="/terms">Termini di Servizio</a> e dalla{" "}
        <a href="/privacy">Informativa Privacy</a>.
      </p>

      <h2>1. Venditore</h2>
      <ul>
        <li><strong>Ragione sociale</strong>: [DA COMPILARE]</li>
        <li><strong>P.IVA / C.F.</strong>: [DA COMPILARE]</li>
        <li><strong>Sede legale</strong>: [DA COMPILARE]</li>
        <li><strong>Contatto ordini</strong>: <a href="mailto:privacy@recenup.com">privacy@recenup.com</a></li>
      </ul>

      <h2>2. Prodotto</h2>
      <p>
        La <strong>RecenUp Card</strong> è una tessera fisica con chip NFC e QR Code stampato,
        associata univocamente all'attività dell'Utente. Consente ai clienti finali di
        raggiungere con un tap o una scansione la pagina di raccolta recensioni Google
        configurata dall'Utente.
      </p>
      <p>
        Il prodotto è concepito come strumento di raccolta feedback. L'Utente è responsabile
        di configurare correttamente il link Google associato e di rispettare le linee
        guida di Google in materia di sollecitazione recensioni.
      </p>

      <h2>3. Listino e modalità di ordine</h2>
      <ul>
        <li><strong>Listino bundle</strong> (primo ordine standard): 1 card €20 · 2 card €35 · 3 card €55 · 4 card €65 · 5 card €80.</li>
        <li><strong>Spedizione</strong>: €5 per ordini fino a 2 card; <strong>gratuita da 3 card in su</strong>.</li>
        <li><strong>Riordino</strong>: prezzo per singola card ridotto rispetto al primo ordine.</li>
        <li><strong>Personalizzazioni oltre 5 card</strong>: prezzo unitario indicato in fase di preventivo.</li>
        <li>Tutti i prezzi sono espressi in EURO, IVA inclusa ove applicabile.</li>
      </ul>
      <p>
        L'ordine viene finalizzato tramite Instant Checkout gestito da <strong>Stripe</strong>
        (metodi accettati: carte Visa/Mastercard, Apple Pay, Google Pay). RecenUp non
        memorizza mai i dati completi della carta.
      </p>

      <h2>4. Ricevuta</h2>
      <p>
        A pagamento riuscito, l'Utente riceve via email una <strong>ricevuta PDF</strong> con
        numerazione progressiva annuale (formato <code>YYYY/NNNN</code>). La ricevuta ha
        valore contabile ma non fiscale ove la normativa non richieda fattura elettronica;
        gli Utenti con partita IVA possono richiedere l'emissione della fattura scrivendo
        a <a href="mailto:privacy@recenup.com">privacy@recenup.com</a> entro 30 giorni
        dall'acquisto.
      </p>

      <h2>5. Consegna</h2>
      <ul>
        <li>Le card vengono prodotte su ordinazione e spedite entro <strong>7-14 giorni lavorativi</strong> dalla conferma di pagamento.</li>
        <li>La spedizione avviene tramite corriere in tutto il territorio italiano e Unione Europea. Per destinazioni extra-UE i termini e i costi sono concordati caso per caso.</li>
        <li>Il rischio del perimento passa al Consumatore al momento della consegna, ai sensi dell'art. 63 del Codice del Consumo.</li>
      </ul>

      <h2>6. Diritto di recesso (solo per Utenti Consumatori)</h2>
      <p>
        Ai sensi degli artt. 52 e ss. del D.Lgs. 206/2005 (Codice del Consumo), il
        Consumatore può recedere dall'acquisto entro <strong>14 giorni</strong> dalla ricezione
        del prodotto senza dover fornire motivazione.
      </p>
      <h3>6.1 Eccezione — prodotto personalizzato</h3>
      <p>
        Ai sensi dell'art. 59, lett. c) del Codice del Consumo, il diritto di recesso{" "}
        <strong>non si applica alle RecenUp Card che riportano personalizzazioni grafiche
        o logo dell'Utente</strong>, in quanto beni confezionati su misura o chiaramente
        personalizzati. Tale limitazione viene richiamata anche in fase di checkout ove
        l'Utente confermi la personalizzazione.
      </p>
      <h3>6.2 Modalità di recesso (card standard)</h3>
      <ul>
        <li>Inviare email a <a href="mailto:privacy@recenup.com">privacy@recenup.com</a> con oggetto "RECESSO ordine [NUMERO RICEVUTA]".</li>
        <li>Riconsegnare il prodotto nella sua confezione originale, in condizioni integre, entro 14 giorni dalla comunicazione di recesso. Le spese di reso sono a carico del Consumatore.</li>
        <li>Il rimborso viene effettuato entro 14 giorni dal ricevimento del reso, sullo stesso mezzo di pagamento utilizzato per l'acquisto.</li>
      </ul>

      <h2>7. Garanzia legale</h2>
      <p>
        Il prodotto è coperto dalla garanzia legale di conformità di 24 mesi ex artt. 128-135
        del Codice del Consumo per gli Utenti Consumatori, e di 12 mesi ex art. 1495 c.c.
        per gli Utenti Professionali.
      </p>
      <p>
        In caso di difetto di conformità (chip NFC non funzionante, QR illeggibile, stampa
        difettosa, ecc.) il Consumatore ha diritto — a sua scelta — alla riparazione,
        sostituzione o rimborso, previa segnalazione scritta a{" "}
        <a href="mailto:privacy@recenup.com">privacy@recenup.com</a> con descrizione del
        difetto e prova d'acquisto.
      </p>

      <h2>8. Programma referral e credito</h2>
      <p>
        Il credito accumulato tramite il programma "Invita & Guadagna" viene applicato
        automaticamente al totale dell'ordine come sconto. Non è convertibile in denaro,
        non è trasferibile e in caso di rimborso viene rilasciato/decrementato di
        conseguenza. Per il funzionamento completo del programma si rinvia ai{" "}
        <a href="/terms">Termini di Servizio</a>, sezione 6.
      </p>

      <h2>9. Reclami e ODR</h2>
      <p>
        Per reclami scrivere a <a href="mailto:privacy@recenup.com">privacy@recenup.com</a>.
        Ai sensi del Reg. UE 524/2013, il Consumatore residente nell'UE può accedere alla
        piattaforma europea di risoluzione delle controversie online (ODR) all'indirizzo{" "}
        <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noreferrer">
          ec.europa.eu/consumers/odr
        </a>.
      </p>

      <h2>10. Legge applicabile e foro competente</h2>
      <p>
        Le presenti condizioni sono regolate dalla legge italiana. Per i Consumatori il
        foro competente è quello di residenza o domicilio; per gli Utenti Professionali il
        foro competente è <strong>[DA COMPILARE: sede legale del Titolare]</strong>.
      </p>
    </LegalLayout>
  );
}
